import React, { useContext } from "react"
import { Modal } from "react-bootstrap";
import {
  Button,
  TextField,
  Checkbox
} from "@mui/material";
import language from "../../../nls/language.json";
import Context from "../../../context/Context";
import '../Combinations.css';

export default function EditCombinationsModal({
  ShowModalEdit,
  setShowModalEdit,
  selectedCombination,
  setSelectedCombination,
  putCombination,
}) {
  const {
    selectedCountry,
  } = useContext(Context);

  return (
    <Modal show={ShowModalEdit} onHide={() => setShowModalEdit(false)}>
      <Modal.Header closeButton>
        <Modal.Title>
          {language[selectedCountry.name].Cadastro.combinacoes.modal.editar.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div className="d-flex flex-row">
            <TextField
              className="mb-3"
              label="Combinação"
              defaultValue={selectedCombination.comb_Nome}
              required
              fullWidth
              id="outlined-basic"
              placeholder="Combinação"
              disabled
            />
            <TextField
              className="mb-3"
              label="Forno"
              defaultValue={selectedCombination.forno}
              required
              fullWidth
              id="outlined-basic"
              placeholder="Combinação"
              disabled
            />

            <TextField
              className="mb-3"
              label="Bomba"
              type="number"
              value={selectedCombination.difBomba}
              placeholder="0"
              disabled
              onChange={({ target }) =>
                setSelectedCombination({
                  ...selectedCombination,
                  bomba: Number(target.value)
                })
              }
              fullWidth
            />
          </div>
          <TextField
            className="mb-3"
            label="Aproveitamento"
            defaultValue={selectedCombination.aproveitamento}
            required
            fullWidth
            id="outlined-basic"
            placeholder="Aproveitamento"
            disabled
          />
          <div>

            <label
              className="form-check-label align-items-center fw-bold h5"
              htmlFor="flexCheckDefault"
            >
              <Checkbox
                id='flexCheckDefault'
                label="Ativo"
                name="ativo"
                className="form-check-input align-items-center me-2"
                checked={selectedCombination.ativo}
                onClick={() => setSelectedCombination({
                  ...selectedCombination,
                  ativo: !selectedCombination.ativo
                })}
              />
              {language[selectedCountry.name].Cadastro.combinacoes.modal.editar.check}
            </label>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="text"
          sx={{ marginRight: 2 }}
          onClick={() => setShowModalEdit(false)}
        >
          {language[selectedCountry.name].Cadastro.combinacoes.modal.editar.btnCancelar}
        </Button>
        <Button
          variant="contained"
          onClick={() => putCombination(selectedCombination)}
        >
          {language[selectedCountry.name].Cadastro.combinacoes.modal.editar.btnSalvar}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

